"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpScheduleEditor = void 0;
const OpScheduleModel_1 = __importDefault(require("@opsbase/lib-data-model/models/OpScheduleModel"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useOpDefinitionPlaces_1 = __importDefault(require("@opsbase/react-gql-hooks/opdefinition/useOpDefinitionPlaces"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const PlaceQueryChooser_1 = __importDefault(require("@opsbase/web-data-choosers/PlaceQueryChooser"));
const Card_1 = __importDefault(require("@opsbase/web-layout/Card"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const OpScheduleEditorWhen_1 = __importDefault(require("./OpScheduleEditorWhen"));
const OpScheduleEditor = function (props) {
    const { opSchedule, onChange } = props;
    const { data: opDefinitionPlaces } = (0, useOpDefinitionPlaces_1.default)({
        variables: { id: opSchedule === null || opSchedule === void 0 ? void 0 : opSchedule.opDefinitionId, limit: 50 },
    });
    const doChange = (0, react_1.useMemo)(() => patch => onChange(new OpScheduleModel_1.default(Object.assign(Object.assign({}, opSchedule), patch))), [onChange, opSchedule]);
    const opSchedulePlacesAreStillValid = (0, react_1.useMemo)(() => {
        if (opSchedule.allPlacesPermitted)
            return true;
        const validPlaceIds = (opDefinitionPlaces === null || opDefinitionPlaces === void 0 ? void 0 : opDefinitionPlaces.map(p => p.id)) || [];
        return opSchedule.places.every(p => validPlaceIds.indexOf(p.id) >= 0);
    }, [opSchedule, opDefinitionPlaces]);
    const handleChangePatch = (0, react_1.useCallback)(patch => doChange(patch), [doChange]);
    const handleChangePlaces = (0, react_1.useCallback)(places => {
        doChange({
            places,
            allPlacesPermitted: !places.length,
        });
    }, [doChange]);
    const handleSelectAll = (0, react_1.useCallback)(allSelected => {
        if (allSelected) {
            doChange({ allPlacesPermitted: true, places: [] });
        }
        else {
            doChange({ allPlacesPermitted: false });
        }
    }, [doChange]);
    const handleChangeSelectedByTag = (0, react_1.useCallback)(placesSelectedByTag => {
        doChange({
            placesSelectedByTag,
            placesSelectedByParent: false,
        });
    }, [doChange]);
    const handleChangePlaceTags = (0, react_1.useCallback)(placeTags => {
        doChange({
            placeTags,
        });
    }, [doChange]);
    const handleChangePlacesSelectedByParent = (0, react_1.useCallback)(placesSelectedByParent => {
        doChange({
            placesSelectedByParent,
            placesSelectedByTag: false,
        });
    }, [doChange]);
    return (react_1.default.createElement(Horizontal_1.default, { stretch: true },
        react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true, style: { maxWidth: '50%' } },
            react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true, justify: "flex-start", alignItems: "flex-bottom" },
                react_1.default.createElement(Text_1.default, { variant: "h1" }, lib_i18n_1.default.t('where')),
                react_1.default.createElement(Text_1.default, { color: "grey" }, lib_i18n_1.default.t('select-schedule-places'))),
            react_1.default.createElement(Card_1.default, { padding: true },
                react_1.default.createElement(Vertical_1.default, { paddingY: true, gutter: true },
                    react_1.default.createElement(PlaceQueryChooser_1.default, { type: 'opschedule', disabled: false, places: opSchedule.places, onChangePlaces: handleChangePlaces, onChangePlaceTags: handleChangePlaceTags, onChangePlacesSelectedByParent: handleChangePlacesSelectedByParent, onChangePlacesSelectedByTag: handleChangeSelectedByTag, placesSelectedByTag: opSchedule.placesSelectedByTag, placeTags: opSchedule.placeTags, placesSelectedByParent: opSchedule.placesSelectedByParent, filterPlaces: opDefinitionPlaces, onSelectAll: handleSelectAll, allPlacesPermitted: opSchedule.allPlacesPermitted }),
                    !opSchedulePlacesAreStillValid && (react_1.default.createElement(Pane_1.default, null,
                        react_1.default.createElement(Text_1.default, { color: lib_palette_1.default.error }, "Note: The specified place is no longer able to perform this Op. This schedule will not run at that place until this is rectified.")))))),
        react_1.default.createElement(Vertical_1.default, { gutter: true, padding: true, style: { maxWidth: '50%' } },
            react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true, justify: "flex-start", alignItems: "flex-bottom" },
                react_1.default.createElement(Text_1.default, { variant: "h1" }, lib_i18n_1.default.t('when'))),
            react_1.default.createElement(Card_1.default, { padding: true },
                react_1.default.createElement(Vertical_1.default, { paddingY: true, gutter: true },
                    react_1.default.createElement(OpScheduleEditorWhen_1.default, { opSchedule: opSchedule, onChange: handleChangePatch }))))));
};
exports.OpScheduleEditor = OpScheduleEditor;
exports.default = exports.OpScheduleEditor;
